import { render, staticRenderFns } from "./PlanilhaPreview.vue?vue&type=template&id=22aa9f83&scoped=true&lang=pug&"
import script from "./PlanilhaPreview.vue?vue&type=script&lang=js&"
export * from "./PlanilhaPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlanilhaPreview.vue?vue&type=style&index=0&id=22aa9f83&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa9f83",
  null
  
)

export default component.exports